import React, { Component } from "react";
import ImgLogo from "../Images/logo_bilapp.png";

var styles = {
    container : {
        width: "100%",
        background: "red",
        height : "20%"
    },
    buttonUl : {
        width     : "100%",
        padding   : "0px",
        listStyle : "none"
    },
    buttonLi : {
        float: "left"
    }
}

export default class PageButtons extends Component {
  render() {
    return(
        <div style={styles.container}>
            <div style={styles.buttonUl}>
                {
                    this.props.buttons.map( 
                        (btn , i) =>
                            <li key={i} style={styles.buttonLi}>
                                {btn}
                            </li>
                    )
                }
            </div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/component_PageButtons.js